module.exports = __webpack_public_path__ + "img/abstract-shapes-10.0b3c04a7.svg";